
<template>
  <div id="app" class="container">
    <div v-if="isFound">
      <div v-for="(itemReceipt, idx) in receiptDataList" :key="idx">
        <!-- <receipt-pdf-CK :item=item >
        </receipt-pdf-CK>-->
        <receipt-pdf-TM v-if="itemReceipt.receipt_type == ReceiptTypeEnum.CASH || itemReceipt.receipt_type == ReceiptTypeEnum.WALLET" :item="itemReceipt"></receipt-pdf-TM>

        <receipt-pdf-CK v-else :item="itemReceipt"></receipt-pdf-CK>
      </div>

      <div id="mybutton">
        <lte-button
          style="float:right;"
          id="cmdPrintPdf"
          type="btn btn-primary pfeedback"
          right_icon="fa fa fa-print"
          @click="onPrintInvoice($event)"
        >{{$t('common.printPdf')}}</lte-button>
      </div>
    </div>

    <div class="error-page" v-else>
      <h2 class="headline text-yellow">404</h2>
      <div class="error-content">
        <h3>
          <i class="fa fa-warning text-yellow"></i>Không Tìm Thấy Dữ Liệu
        </h3>
      </div>
    </div>

    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "bootstrap-vue/dist/bootstrap-vue.css";
import ComponentReceiptPdf_CK from "./ComponentReceiptPdf_CK";
import ComponentReceiptPdf_TM from "./ComponentReceiptPdf_TMV2";
import LTEButton from "@/components/LTEButton.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import ReceiptTypeEnum from "@/enum/receiptTypeEnum";

export default {
  name: "ReceiptPdfFilter",
  data() {
    return {
      ReceiptTypeEnum: ReceiptTypeEnum,
      receiptDataList: [],
      period: 0,
      isLoading: false,
      isFound: true
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    // timeout 500ms
    timeout: function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    onPrintInvoice: async function() {
      await utils.sleep(1000);

      // document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      // document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_RECEIPT_LIST_BY_ID"
    ])
  },
  async mounted() {
    this.isLoading = true;
    const data = {
      ids: this.$route.query.ids
    };

    // Set data for select USER_LIST - [ACTION_01]
    await this.GET_RECEIPT_LIST_BY_ID(data).then(
      function(res) {
        this.receiptDataList = res.data;
        this.isLoading = false;
        if (this.receiptDataList.length <= 0) {
          this.isFound = false;
        }
      }.bind(this)
    );
  },
  components: {
    "receipt-pdf-CK": ComponentReceiptPdf_CK,
    "receipt-pdf-TM": ComponentReceiptPdf_TM,
    "lte-button": LTEButton,
    loading: Loading
  }
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 2px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 2px solid #000000;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptPdfFilter.vue